import { useEffect } from "react";
import "./Dashboard.css";

import RecentOrdersCollection from "./Components/RecentOrdersCollection/RecentOrdersCollection";
import DashboardStats from "./Components/DashboardStats/DashboardStats";
import SalesOverview from "./Components/SalesOverview/SalesOverview";
import SalesByCategory from "./Components/SalesByCategory/SalesByCategory";

import CouponPerformanceGraph from "./Components/CouponPerformance/CouponPerformance.Graph";
import PurchaseRatio from "./Components/PurchaseRatio/PurchaseRatio";
import ReturnRatioGraph from "./Components/ReturnRatio/ReturnRatio.Graph";

import {
    coupons,
    returnRatio,
    productReviews,
} from "./ChartData";
import ProductReviewsGraph from "./Components/ProductReviews/ProductReviews.Graph";
import DropTrackAnalytics from "./Components/DropTrackAnalytics/DropTrackAnalytics";
import ProductInsights from "./Components/ProductInsights/ProductInsights";
import LowInventoryStock from "./Components/LowInventoryStock/LowInventoryStock";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboard } from '../../Features/dashboardSlice';
import { formatUserName } from "../../lib/utils/utils";

export default function Home() {
    const dispatch = useDispatch();

    const user = useSelector((state) => state.user.user);

    useEffect(() => {
        dispatch(fetchDashboard());
        // eslint-disable-next-line
    }, []);

    return (
        <div className="w-full overflow-y-scroll pb-16 outline-none">
            <div className="flex flex-col gap-6 relative m-[20px_19px_24px_20px]">
                <h1 className="text-[#121212] font-bold text-2xl">Hello, {formatUserName(user?.name)}</h1>
            </div>

            <DashboardStats />

            <div className="grid grid-cols-5 mt-3 gap-3 mx-5">
                <SalesOverview />

                <SalesByCategory />
            </div>

            <div className="grid grid-cols-3 mt-3 gap-3 mx-5">
                <CouponPerformanceGraph couponData={coupons} />

                <PurchaseRatio />

                <ReturnRatioGraph returnRatioData={returnRatio} />
            </div>

            <div className="grid grid-cols-5 mt-3 gap-3 mx-5">
                <ProductReviewsGraph productReviewsData={productReviews} />

                <DropTrackAnalytics />
            </div>

            <div className="grid grid-cols-5 mt-3 gap-3 mx-5">
                <ProductInsights />

                <LowInventoryStock />
            </div>

            <RecentOrdersCollection />
        </div>
    );
}
